// Shared phone helpers
export const sanitizePhoneDigits = (value = '') => {
  let digits = (value || '').replace(/\D/g, '');
  if (digits.startsWith('1')) digits = digits.slice(0, 11); else digits = digits.slice(0, 10);
  return digits;
};

export const formatPhoneProgressive = (digits = '') => {
  if (!digits) return '';
  let d = digits;
  let prefix = '';
  if (d.startsWith('1')) { prefix = '+1 '; d = d.slice(1); }
  if (d.length <= 3) return `${prefix}(${d}`;
  if (d.length <= 6) return `${prefix}(${d.slice(0,3)}) ${d.slice(3)}`;
  return `${prefix}(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;
};

export const isCompletePhone = (digits = '') => (
  digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))
);
